"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// this service was created to interface with the Grind Team's 'storage service'
// eslint-disable-next-line max-len
// swagger docs can be found here: https://api-devci.poc.learning.amplify.com/openapi-ui/?urls.primaryName=endpoint-ui%3A%20worksheet-service%20%40%20devci
var worksheet = new _GatewayService["default"]('worksheet-svc');

var fetchWorksheet = function fetchWorksheet(userKey, cardKey) {
  var axiosOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var axiosConfig = {};
  Object.assign(axiosConfig, axiosOptions);
  return worksheetExists(userKey, cardKey).then(function (exists) {
    if (exists) {
      return worksheet.get("storage/item/".concat(userKey, "/").concat(cardKey), axiosConfig);
    } else {
      return;
    }
  });
};

var worksheetExists = function worksheetExists(userKey, cardKey) {
  return worksheet.get("storage/list/".concat(userKey, "/").concat(cardKey), {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (data) {
    return data.includes("".concat(userKey, "/").concat(cardKey));
  });
};
/**
 * @param {Array<Array<String>>} userKeyTuplesList user/cardstackkey tuples
 * @return {Promise<Array<Object>>} A promise resolving to an array of submissions
 * grouped by cardstacks and userId.
 */


var fetchBulkWorksheets = function fetchBulkWorksheets(userKeyTuplesList) {
  return worksheet.post('storage/batchAll', userKeyTuplesList, {
    params: {
      includeData: true
    }
  }).then(function (resp) {
    return _lodash["default"].map(resp, function (submissionGroup) {
      return JSON.parse(submissionGroup.content);
    });
  });
};

var writeWorksheet = function writeWorksheet(userKey, cardstackKey, response) {
  var axiosOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var axiosConfig = {
    headers: {
      'Content-Type': 'text/plain'
    }
  };
  Object.assign(axiosConfig, axiosOptions);
  return worksheet.post("storage/".concat(userKey, "/").concat(cardstackKey), response, axiosConfig);
};

var deleteWorksheet = function deleteWorksheet(userKey, cardkey) {
  return worksheet["delete"]("storage/".concat(userKey, "/").concat(cardkey), {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var deleteWorksheets = function deleteWorksheets(userKey) {
  var cardkeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return worksheet["delete"]("storage/all/".concat(userKey), {
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(cardkeys)
  });
};

var _default = {
  fetchWorksheet: fetchWorksheet,
  fetchBulkWorksheets: fetchBulkWorksheets,
  writeWorksheet: writeWorksheet,
  deleteWorksheets: deleteWorksheets,
  deleteWorksheet: deleteWorksheet
};
exports["default"] = _default;